import type {ImageField, KeyTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'
import type {FC} from 'react'

type TagProps = {
  icon?: ImageField
  text?: KeyTextField
}

/**
 * Tag - A reusable pill-shaped tag component with optional icon
 *
 * Features:
 * - Displays text in a rounded pill shape
 * - Optional icon with gradient background
 * - Consistent styling across the application
 */
export const Tag: FC<TagProps> = ({icon, text}) => {
  if (!isFilled.keyText(text)) {
    return null
  }

  const hasIcon = isFilled.image(icon)

  return (
    <div
      className={cn(
        'flex h-[36px] items-center gap-2.5 rounded-full border border-black/10 bg-moss-white p-4',
        hasIcon ? 'pl-[7px]' : 'pl-4',
      )}
    >
      {hasIcon && (
        <div className="flex size-6 items-center justify-center overflow-hidden rounded-full bg-[linear-gradient(330deg,#AF57F7_34.41%,#D9ABFF_102.12%)]">
          <PrismicNextImage field={icon} className="size-4 object-contain" />
        </div>
      )}
      <span className="text-button-xs md:text-button uppercase text-moss-grey-500">{text}</span>
    </div>
  )
}
